import axios, { AxiosRequestConfig } from "axios"
import { getBBUserFromLocalStorage } from "./localStorage"

let store: any

export const injectStore = (_store: any) => {
  store = _store
}

const api = axios.create({
  baseURL: process.env.REACT_APP_API_HOST ?? "/",
  withCredentials: true
})

// Add request interceptor to add auth token to all requests
api.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const user = getBBUserFromLocalStorage()
    if (user?.sessid && config.headers) {
      config.headers.Authorization = user.sessid
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

api.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      store.dispatch({ type: "auth/sessionExpired" })
    }
    return Promise.reject(error)
  }
)

export default api

export const getQueryString = (params: {
  [key: string]: number | string | boolean | undefined
}): string => {
  const str = Object.keys(params ?? {})
    .filter(
      k => params[k] !== null && params[k] !== undefined && params[k] !== ""
    )
    .map(k => `${k}=${params[k]}`)
    .join("&")

  return str ? `?${str}` : ""
}
